export default __webpack_public_path__ + "static/media/Delete.117a6a16.svg";